var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-row',{staticClass:"mt-4"},_vm._l((_vm.filterTypes),function(filter,index){return _c('div',{key:index,staticClass:"vx-col w-1/2",staticStyle:{"padding-right":"0.375rem"}},[_c('todo-filter-card',{attrs:{"filter":filter.filter,"name":filter.name,"color":filter.color,"icon":filter.icon}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }